import { IComponentOptions } from "angular";

import { GtmhubController } from "@gtmhub/core";
import { v4 as uuidv4 } from "uuid";

interface IGridSettingsComponentBindings {
  buttonTitle: string;
  iconType: string;
  toggleTooltip?: string;
  toggleTooltipPlacement?:
    | "top"
    | "bottom"
    | "left"
    | "right"
    | "top-left"
    | "top-right"
    | "bottom-left"
    | "bottom-right"
    | "left-top"
    | "left-bottom"
    | "right-top"
    | "right-bottom";
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface GridSettingsComponentCtrl extends IGridSettingsComponentBindings {}
export class GridSettingsComponentCtrl extends GtmhubController {
  toggleId: string;

  static $inject = [];

  constructor() {
    super();
    this.toggleId = uuidv4();
  }
}

export const GridSettingsComponent: IComponentOptions = {
  templateUrl: require("./grid-settings.jade"),
  controller: GridSettingsComponentCtrl,
  require: { gridFilteringBar: "^" },
  bindings: {
    buttonTitle: "@",
    iconType: "@",
    toggleTooltip: "@?",
    toggleTooltipPlacement: "@?",
  },
  transclude: true,
};
